export class Size {
    width: number;
    height: number;

    constructor();
    constructor(json: any);
    constructor(width: number, height: number)
    constructor(widthOrJson?: any, height?: number) {
        if (widthOrJson) {
            this.width = widthOrJson;
            this.height = height;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/size.ts